import { isUndefined } from "lodash";

// Overwrite default vue-router `push` behavior so that redirection in
// navigation guards (like `beforeEnter`) don't throw `undefined` errors.
// ----------------------------------------------------------------------------
//
// Starting in vue-router v3.1 calls to `$router.push` and `$router.replace`
// return a promise. This promise will throw an exception if vue-router fails
// to navigate to the requested route *for any reason*. Even a redirect in a
// navigation guard counts as a "failure" and an exception is thrown.
// Source: https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
//
// In the case of our community and system selection Vue components redirection
// can take place if the user has already selected a community. While perfectly
// valid, this is still a "failure" from vue-router's perspective and an
// exception is thrown each time, which, in turn, gets reported to BugSnag. To
// further complicate matters vue-router throws an `undefined` object instead
// of a proper Error object, making it difficult to track.
//
// The "proper" way to handle this is to catch the error at the call site of
// `$router.push` or `$router.replace`. However, in our case, there are many
// places where navigation to these reusable community/system selection vue
// components are used.
//
// A better solution for our use-case is to ignore exceptions thrown by
// vue-router that are `undefined`. In the future this may need to be updated
// if they fix it so that a proper error object is thrown.
export default function patchRouter(router) {
	router.push = wrap(router.push);
	router.replace = wrap(router.replace);

	function wrap(orig) {
		return function(location, onResolve, onReject) {
			if (onResolve || onReject) {
				return orig.call(this, location, onResolve, onReject);
			}

			return orig.call(this, location).catch(err => {
				if (!isUndefined(err)) {
					// If there really is an error, throw it.
					return Promise.reject(err);
				}

				// Otherwise resolve to false to indicate the original push call
				// didn't go to it's original destination.
				return Promise.resolve(false);
			});
		};
	}
	return router;
}
